import React from "react";
import { IShop } from "interfaces";
import cls from "./shopList.module.scss";
import { Grid, Skeleton, useMediaQuery } from "@mui/material";
import ShopCard from "components/shopCard/shopCard";
import { useTranslation } from "react-i18next";
import LoadMore from "components/button/load-more";
import Empty from "components/empty/empty";

type Props = {
  title?: string;
  shops: IShop[];
  loading?: boolean;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  fetchingNextPage?: boolean;
};

export default function ShopList({
  title,
  shops,
  loading,
  fetchNextPage,
  hasNextPage = false,
  fetchingNextPage = false,
}: Props) {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery("(min-width:1140px)");
  const handleLoadNexPage = () => {
    if (hasNextPage && fetchNextPage) {
      fetchNextPage();
    }
  };

  if (!loading && !shops?.length) {
    return <Empty text={t("no.shops.found")} />;
  }

  return (
    <section
      className={cls.container}
      style={{
        display: !loading && shops.length === 0 ? "none" : "block",
      }}
    >
      <div className={cls.wrapper}>
        <div className={cls.header}>
          <h2 className={cls.title}>{title}</h2>
        </div>
        <Grid container spacing={isDesktop ? 4 : 2}>
          {!loading
            ? shops.map((item) => (
                <Grid key={item.id} item xs={12} sm={6} lg={3}>
                  <ShopCard data={item} />
                </Grid>
              ))
            : Array.from(new Array(4)).map((_, idx) => (
                <Grid key={"shops" + idx} item xs={12} sm={6} lg={3}>
                  <Skeleton variant="rectangular" className={cls.shimmer} />
                </Grid>
              ))}
        </Grid>
        {hasNextPage && (
          <div className={cls.loadMore}>
            <LoadMore loading={fetchingNextPage} onClick={handleLoadNexPage}>
              {t("load.more")}
            </LoadMore>
          </div>
        )}
      </div>
    </section>
  );
}
